module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_7-8d71d490cc9777dead18a3d242187761.png";